<template>
  <b-container>
    <b-row class="mt-3">
      <b-col>
        <b-form-input
          id="small-input"
          ref="searchmoduleinput"
          v-model="searchString"
          :placeholder="$t('search')"
        />
        <div id="checkbox-grid">
          <b-form-checkbox
            v-for="category in categories"
            :key="category"
            @change="checkTopCategory(category, $event)"
            >{{ $t("bom.medium." + category) }}</b-form-checkbox
          >
        </div>
      </b-col>
    </b-row>

    <template
      v-for="(modules, i) in [recommendedModules, requiredFuseBoxModules]"
    >
      <div
        v-if="modules.length > 0"
        :key="i"
        :class="{
          'favorite-modules': true,
        }"
      >
        <b-col>
          <div class="headline">
            <h5 class="categories-headline">
              {{ i == 0 ? $t("feeding.add") : $t("addWiring") }}
            </h5>
          </div>
          <b-row class="">
            <b-col
              sm="4"
              md="3"
              class="show-module p-2"
              v-for="(module, j) in modules"
              :key="`module-${module.itemNumber}-${j}`"
              @click="$emit('addModule', module)"
              :draggable="!disabled"
              @dragstart="$emit('dragStart', { event: $event, module })"
              @dragend="$emit('dragEnd', $event)"
            >
              <div class="module-image-container">
                <b-img
                  :id="module.itemNumber"
                  class="module-image"
                  fluid
                  :src="imageUrlForModule(module.itemNumber)"
                />
              </div>
              <div id="module-font-size">
                <div>
                  {{
                    module.description.replace(/^module? (M\/L|XS\/S) /i, "")
                  }}
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </div>
    </template>
    <div class="categories" v-for="type in types" :key="type.name">
      <b-row>
        <!-- <b-col> -->
        <h5
          class="categories-headline"
          v-if="filteredModulesWithType(type.name).some((a) => a.type)"
        >
          {{ $t("bom.modules." + type.name) }}
        </h5>
        <!-- </b-col> -->
      </b-row>

      <b-row class="">
        <b-col
          sm="4"
          md="3"
          class="show-module p-2"
          v-for="(module, k) in filteredModulesWithType(type.name)"
          :key="`module-${module.itemNumber}-${k}`"
          :draggable="!disabled"
          @dragstart="$emit('dragStart', { event: $event, module })"
          @dragend="$emit('dragEnd', $event)"
          @click="$emit('addModule', module)"
        >
          <div class="text-center">
            <b-img
              class="module-image"
              :id="module.itemNumber"
              fluid
              :src="imageUrlForModule(module.itemNumber)"
            />
          </div>
          <div id="module-font-size" class="">
            <!-- test -->
            <div>
              {{ module.description.replace(/^module? (M\/L|XS\/S) /i, "") }}
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { score } from "fuzzaldrin-plus";
import breakerMixin from "./breakerMixin.js";

export default {
  mixins: [breakerMixin],
  data() {
    return {
      selectedCategories: [],
      searchString: "",
    };
  },
  mounted() {
    this.setFocusOnSearchField();
  },
  props: {
    recommendedModules: {
      type: Array,
    },
    columnType: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
  },
  computed: {
    modules() {
      return this.$store.state.modules
    },
    types() {
      let types = [];
      this.modules.forEach((module) => {
        const typeName = module.type;
        let type = types.find((t) => t.name == typeName);
        if (!type) {
          type = {
            name: typeName,
          };
          types.push(type);
        }
      });

      const priority = (a) =>
        a.name == "Tapping" || a.name == "Abgriff"
          ? 3
          : a.name == "Feeding" || a.name == "Einspeisung"
          ? 2
          : a.name == "Hedge" || a.name == "Absicherung"
          ? 1
          : a.name == "Empty modules" || a.name == "Leermodul"
          ? -1
          : 0;

      types.sort((a, b) => priority(b) - priority(a));
      return types;
    },
    filteredModules: function () {
      if (this.modules == null) return [];
      let modules = this.modules.slice().sort(function (a, b) {
        if (a.type < b.type) return -1;
        if (a.type > b.type) return 1;
        if (a.category < b.category) return 1;
        if (a.category > b.category) return -1;
      });

      if (this.selectedCategories.length > 0) {
        modules = modules.filter((x) =>
          this.selectedCategories.includes(x.medium)
        );
      }

      if (this.searchString.length == 0) return modules;

      return modules
        .map((module) => {
          return {
            module,
            score:
              score(module.description, this.searchString) +
              score(module.medium, this.searchString),
          };
        })
        .filter((x) => x.score > 0.5)
        .sort((a, b) => b.score - a.score)
        .map((x) => x.module);
    },
    categories() {
      if (this.modules == null || this.modules.length == 0) return [];

      return [
        ...new Set(
          this.modules.map((module) => module.medium).filter((x) => x != null)
        ),
      ];
    },
  },
  methods: {
    setFocusOnSearchField() {
      this.$nextTick(() => {
        this.$refs.searchmoduleinput.focus();
      });
    },
    imageUrlForModule(id) {
      return `${process.env.VUE_APP_API}/modules/${id}/image`;
    },
    showFeedingDialog() {
      if (this.requiredFuseBoxModules.length > 0) {
        this.boxOne = "";
        this.$bvModal
          .msgBoxOk(this.$t("warnings.circuitBreakerHeading"), {
            title: this.$t("warnings.circuitBreakerText"),
            size: "md",
            buttonSize: "md",
            okVariant: "danger",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then((value) => {
            this.boxOne = value;
          });
      } else this.$emit("showFeedingDialog");
    },
    filteredModulesWithType(type) {
      return this.filteredModules
        .filter(
          (m) =>
            m.type == type &&
            m.compatibleColumnTypes.includes(this.columnType.id) &&
            m.mountingArea != "HEAD"
        )
        .filter((m) => {
          if (m.type == "EMPTY") return m.slotHeight <= 3;
          else return true;
        });
    },
    checkTopCategory(category, value) {
      if (value) {
        const alreadyInList = this.selectedCategories.some(
          (cat) => cat == category
        );
        if (!alreadyInList) {
          this.selectedCategories.push(category);
        }
      } else {
        this.selectedCategories = this.selectedCategories.filter(
          (cat) => cat != category
        );
      }
    },
  },
};
</script>

<style lang="scss">
#checkbox-grid {
  margin: 15px 10px 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.favorite-modules {
  border: solid indianred 2px;
  background-color: white;
  color: indianred;
  padding: 10px 5px;
}

.disabled-transparent {
  opacity: 0.7;
}

.categories {
  color: black;
}

.next-button {
  height: 2.2em;
  align-self: center;
  margin-top: 0.5em;
  padding: 0.375rem 1.5rem;
}

.modulesidebar-button-box {
  display: flex;
  justify-content: space-around;
}

.module-image {
  max-width: 60px;
  max-height: 60px;
  margin-bottom: 5px;
  pointer-events: none;
}

.headline-hr {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 15px;
}

.categories-headline {
  text-align: left;
  font-size: 19px;
  text-transform: capitalize;
  margin-top: 25px;
}

.show-module {
  cursor: pointer;
  text-align: center;
  &:hover {
    background: #f0f0f0;
  }
}
#module-font-size {
  font-size: 8pt;
  text-align: center;
}

.headline {
  display: flex;
}

.headline-icon {
  cursor: pointer;
  margin-left: 5px;
  margin-top: 3px;
}
</style>
